import React, { createContext, useContext, useState, useEffect } from 'react';
import { useMediaQuery, useTheme } from '@mui/material';

const SidebarContext = createContext();

export function useSidebar() {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error('useSidebar must be used within a SidebarProvider');
  }
  return context;
}

export function SidebarProvider({ children }) {
  const theme = useTheme();
  // noSsr: true avoids hydration mismatch and ensures we get real viewport after mount (important for Vercel/production)
  const isMobile = useMediaQuery(theme.breakpoints.down('md'), { noSsr: true });
  // Default to true (sidebar open) so desktop users see sidebar on first paint; useEffect syncs to !isMobile once query is ready
  const [sidebarOpen, setSidebarOpen] = useState(true);

  // Sync sidebar state when viewport (isMobile) is known or changes
  useEffect(() => {
    setSidebarOpen(!isMobile);
  }, [isMobile]);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <SidebarContext.Provider value={{ sidebarOpen, setSidebarOpen, toggleSidebar, isMobile }}>
      {children}
    </SidebarContext.Provider>
  );
}
